/**
 * Step-up price tracking — see sections/combo-stepup.liquid.
 *
 * Recomputes from the numbers `biosphere:combo:change` carries; never reads the buy
 * block's DOM. The money formatter is duplicated from biosphere-combo-buy.js on
 * purpose: shared logic moves to a module at the third consumer (assets/CLAUDE.md).
 */
(function () {
  var root = document.querySelector(".biosphere-combo-stepup");
  if (!root) return;

  var priceEl = root.querySelector(".biosphere-combo-stepup__price");
  var deltaEl = root.querySelector(".biosphere-combo-stepup__delta");
  var configEl = root.querySelector(".biosphere-combo-stepup__config");
  if (!priceEl || !deltaEl || !configEl) return;

  var config = {};
  try {
    config = JSON.parse(configEl.textContent) || {};
  } catch (error) {
    return;
  }

  var steps = config.steps || [];
  var extras = config.extras || [];
  // Server-rendered, then replaced by whatever the buy block last reported.
  var comboItems = config.items || [];

  var extraTotal = parseInt(root.dataset.extraTotal, 10) || 0;
  var extraCount = parseInt(root.dataset.extraCount, 10) || 0;
  var deltaTemplate = root.dataset.deltaTemplate || "";
  var moneyFormat = root.dataset.moneyFormat || "{{amount}}";

  function digits(cents, withDecimals, thousands, point) {
    var negative = cents < 0;
    var absolute = Math.abs(Math.round(cents));
    var units = withDecimals
      ? Math.floor(absolute / 100)
      : Math.round(absolute / 100);
    var whole = String(units).replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var fraction = String(absolute % 100).padStart(2, "0");
    return (
      (negative ? "-" : "") + whole + (withDecimals ? point + fraction : "")
    );
  }

  function money(cents) {
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (whole, name) {
      switch (name) {
        case "amount_no_decimals":
          return digits(cents, false, ",", ".");
        case "amount_with_comma_separator":
          return digits(cents, true, ".", ",");
        case "amount_no_decimals_with_comma_separator":
          return digits(cents, false, ".", ",");
        case "amount_with_space_separator":
          return digits(cents, true, " ", ",");
        case "amount_no_decimals_with_space_separator":
          return digits(cents, false, " ", ",");
        case "amount_with_apostrophe_separator":
          return digits(cents, true, "'", ".");
        default:
          return digits(cents, true, ",", ".");
      }
    });
  }

  function percentFor(units) {
    var percent = 0;
    steps.forEach(function (step) {
      if (units >= step.quantity && step.percent > percent) {
        percent = step.percent;
      }
    });
    return percent;
  }

  var submit = root.querySelector(".biosphere-combo-stepup__submit");
  var errorEl = root.querySelector(".biosphere-combo-stepup__error");
  var liveEl = root.querySelector(".biosphere-combo-stepup__live");
  var busy = false;

  document.addEventListener("biosphere:combo:change", function (event) {
    var state = event.detail;
    if (!state) return;
    if (state.items) comboItems = state.items;

    var units = state.units + extraCount;
    var gross = state.gross + extraTotal;
    var percent = percentFor(units);
    var total = gross - Math.round((gross * percent) / 100);

    priceEl.textContent = money(total);
    deltaEl.textContent = deltaTemplate
      .replace("[added]", money(total - state.total))
      .replace("[shelf]", money(extraTotal))
      .replace("[count]", String(units))
      .replace("[percent]", String(percent));
  });

  /* Revealed only once the script is running, as the buy block does. */
  if (!submit || !extras.length) return;

  for (
    var i = 0;
    i < root.querySelectorAll(".biosphere-combo-stepup__form").length;
    i++
  ) {
    root.querySelectorAll(".biosphere-combo-stepup__form")[i].hidden = true;
  }
  submit.hidden = false;

  function announce(message) {
    if (liveEl) liveEl.textContent = message;
  }

  function fail(message) {
    busy = false;
    submit.disabled = false;
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }
    announce(message);
  }

  /* The drawer opened on cart:adding and only cart:change releases it, so a failed
     add publishes too — with no cart, which every subscriber guards. */
  function release() {
    document.dispatchEvent(
      new CustomEvent("biosphere:cart:change", {
        detail: { cart: null, action: "update", source: "combo-stepup" },
      }),
    );
  }

  submit.addEventListener("click", function () {
    if (busy || !comboItems.length) return;
    busy = true;
    submit.disabled = true;

    var items = comboItems.concat(extras);

    document.dispatchEvent(
      new CustomEvent("biosphere:cart:adding", {
        detail: { source: "combo-stepup" },
      }),
    );

    fetch(root.dataset.cartAddUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        if (payload && payload.status) {
          fail(payload.message || root.dataset.errorNetwork || "");
          return null;
        }
        if (errorEl) errorEl.hidden = true;
        announce(root.dataset.addedMessage || "");
        return fetch(root.dataset.cartUrl + ".json", {
          cache: "no-store",
          headers: { Accept: "application/json" },
        }).then(function (response) {
          return response.json();
        });
      })
      .then(function (cart) {
        if (!cart) {
          release();
          return;
        }
        document.dispatchEvent(
          new CustomEvent("biosphere:cart:change", {
            detail: { cart: cart, action: "add", source: "combo-stepup" },
          }),
        );
        busy = false;
        submit.disabled = false;
      })
      .catch(function () {
        fail(root.dataset.errorNetwork || "");
        release();
      });
  });
})();
